import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import type { TabItem } from '@wix/da-ds/pkg/Tabs';
import { StudioSection } from '../../../../../types/store';
import { getActiveSection } from '../../../../../selectors/studio';

import s from './DiscountTabs.scss';

interface Props {}

const DiscountTabs: FC<Props> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const activeTab = useSelector(getActiveSection);

  return (
    <UnderlinedTabs
      className={s['root']}
      uniformTabWidth={isMobile}
      items={
        [
          {
            label: t('studio.header.tabs.discounts.subtabs.active'),
            index: StudioSection.SELLER_DISCOUNTS_ACTIVE,
            href: Url.studio({ section: 'discounts', discounts: 'active' }),
          },
          {
            label: t('studio.header.tabs.discounts.subtabs.scheduled'),
            index: StudioSection.SELLER_DISCOUNTS_SCHEDULED,
            href: Url.studio({ section: 'discounts', discounts: 'scheduled' }),
          },
          {
            label: t('studio.header.tabs.discounts.subtabs.ended'),
            index: StudioSection.SELLER_DISCOUNTS_ENDED,
            href: Url.studio({ section: 'discounts', discounts: 'ended' }),
          },
        ].filter(item => !!item) as TabItem[]
      }
      activeIndex={activeTab}
    />
  );
};

DiscountTabs.displayName = 'DiscountTabs';

export default DiscountTabs;
